import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import { formatCouponDate, plusComma } from '../../js/script'
import { imgURL } from '../Footer'
import { OrderSheetCoupon } from '@shopby/shop-sdk'

type Props = {
  setIsModal: (v: boolean) => void
  cartCoupons: OrderSheetCoupon[]
  selectedCoupon: OrderSheetCoupon | null | undefined
  onApplyCoupon: (coupon: OrderSheetCoupon | null) => void
}

const OrderCartCouponModal = ({ setIsModal, cartCoupons, selectedCoupon, onApplyCoupon }: Props) => {
  const [closing, setClosing] = useState(false)
  const [nowSelectedCoupon, setNowSelectedCoupon] = useState<OrderSheetCoupon | null>(selectedCoupon ?? null)

  const couponDescription = (coupon: OrderSheetCoupon) => {
    return `${formatCouponDate(coupon.useEndYmdt)} 까지`
    // return `${
    //   coupon.fixedAmountDiscount
    //     ? `${plusComma(coupon.couponDiscountAmt)}원 할인`
    //     : `${coupon.discountRate}% (최대 ${plusComma(coupon.maxDiscountAmt)}원 할인)`
    // } / ${formatCouponDate(coupon.useEndYmdt)} 까지`
  }

  const couponDiscountAmt = (coupon: OrderSheetCoupon) => {
    return coupon.fixedAmountDiscount ? `${plusComma(coupon.couponDiscountAmt)}원` : `${coupon.discountRate}%`
  }

  const couponMaxDiscountAmt = (coupon: OrderSheetCoupon) => {
    return coupon.fixedAmountDiscount ? '' : ` (최대 ${plusComma(coupon.maxDiscountAmt)}원 할인)`
  }

  const closeModal = () => {
    setClosing(true)
    setTimeout(() => {
      setIsModal(false)
      setClosing(false)
    }, 280)
  }

  const handleApplyCoupon = () => {
    onApplyCoupon(nowSelectedCoupon)
    closeModal()
  }

  useEffect(() => {
    setNowSelectedCoupon(selectedCoupon ?? null)
  }, [selectedCoupon])

  // 모달 오픈 시 body 스크롤 막기
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>
            사용 가능 쿠폰
            <span>{cartCoupons.length}</span>
          </p>
          <button className='btn_close' onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt='닫기' />
          </button>
        </ModalHeader>
        <ModalBody>
          <CouponBox>
            {cartCoupons.map((coupon, idx) => (
              <CouponItem key={coupon.couponIssueNo}>
                <input
                  type='radio'
                  id={`cart_coupon_${idx}`}
                  name='cart_coupon_radio'
                  checked={nowSelectedCoupon?.couponIssueNo === coupon.couponIssueNo}
                  onChange={() => setNowSelectedCoupon(coupon)}
                  style={{ display: 'none' }}
                />
                <label
                  htmlFor={`cart_coupon_${idx}`}
                  style={{
                    padding: '20px',
                    border:
                      nowSelectedCoupon?.couponIssueNo === coupon.couponIssueNo
                        ? '1px solid var(--colPointBlue)'
                        : '1px solid var(--colGray3)',
                    borderRadius: '6px',
                    display: 'block',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    if (nowSelectedCoupon?.couponIssueNo === coupon.couponIssueNo) {
                      setNowSelectedCoupon(null)
                    } else {
                      setNowSelectedCoupon(coupon)
                    }
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: '15px',
                        lineHeight: '20px',
                        color: 'var(--colBlack)',
                      }}
                    >
                      {coupon.couponName}
                    </p>
                    <span
                      style={{
                        fontSize: '12px',
                        lineHeight: '15px',
                        color: 'var(--colGray6)',
                        display: 'block',
                        marginTop: '4px',
                      }}
                    >
                      {couponDescription(coupon)}
                    </span>
                    <strong
                      style={{
                        fontSize: '24px',
                        lineHeight: '26px',
                        color: 'var(--colPointBlue)',
                        display: 'block',
                        marginTop: '8px',
                      }}
                    >
                      {/* NOTE: 아래 장바구니 쿠폰 이슈로 couponDiscountAmt은 현재 사용하지 않으나 정상 작동시 사용 부탁드립니다. */}
                      {/* {plusComma(coupon.couponDiscountAmt)}원 */}
                      {couponDiscountAmt(coupon)}
                      <span style={{ fontSize: '12px', fontWeight: 500, color: 'var(--colBlack)' }}>
                        {couponMaxDiscountAmt(coupon)}
                      </span>
                    </strong>
                  </div>
                </label>
              </CouponItem>
            ))}
          </CouponBox>
        </ModalBody>
        <ModalFooter>
          <div
            onClick={closeModal}
            style={{
              width: '100%',
              textAlign: 'center',
              borderRadius: '5px',
              border: '1px solid var(--colGray3)',
              fontSize: '14px',
              lineHeight: '46px',
              cursor: 'pointer',
            }}
          >
            취소
          </div>
          <div
            style={{
              width: '100%',
              textAlign: 'center',
              borderRadius: '5px',
              background: 'var(--colBlack)',
              color: 'var(--colWhite)',
              fontSize: '14px',
              lineHeight: '48px',
              cursor: 'pointer',
            }}
            onClick={handleApplyCoupon}
          >
            확인
          </div>
        </ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing} />
    </ModalWrap>
  )
}

interface typeProps {
  closing?: boolean
}

const ModalBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 900;
`

const ModalBox = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;

  @media screen and (min-width: 1024px) {
    width: 420px;
    min-height: 280px;
    max-height: 90vh;
    left: 50%;
    top: 50%;
    bottom: auto;
    transform: translate(-50%, -50%);
    border-radius: 22px;
    animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
    position: fixed;
  }
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18.5px 22px 0 33px;
  & p {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }
  & p span {
    display: inline-block;
    color: var(--colPointBlue);
    margin-left: 4px;
  }
  & button.btn_close {
    width: 41px;
    height: 48px;
    padding: 12px 8px 12px 9px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }

  @media screen and (min-width: 1024px) {
    padding: 6px 10px 0 20px;
  }
`

const ModalBody = styled.div``

const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  margin: 0 20px;
`

const CouponBox = styled.div`
  display: flex;
  margin: 8px 20px;
  flex-direction: column;
  gap: 12px;
  max-height: 328px;
  min-height: 129px;
  overflow-y: auto;
`

const CouponItem = styled.div``

export default OrderCartCouponModal
